var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "600px",
    height: "600px",
    xlink: "http://www.w3.org/1999/xlink",
    style: {
      overflow: "hidden!important"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-wrapper",
    transform: "scale(3 3)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-backs-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2877",
    d: "M225 225H-25V-25h250V225z",
    fill: "transparent",
    strokeWidth: "none",
    opacity: 1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "svga-group-subwrapper",
    transform: "matrix(0.84999948 0 0 0.84999948 14.979251146640621 17.207872153750003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-back"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4438",
    d: "M100.5,100.5h-1v-1h1V100.5z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-humanbody-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2893",
    d: "M195.417 199.778c-2.196-4.746-8.195-11.779-14.86-13.722 -8.239-2.403-26.837-5.308-33.733-6.923 -5.528-1.296-16.662-11.294-20.564-14.65 -0.7-0.6-1.273-1.839-1.287-2.76 -0.139-10.864 4.195-39.724 4.195-39.724H100 70.833c0 0 4.334 28.859 4.193 39.724 -0.011 0.921-0.587 2.16-1.285 2.76 -3.902 3.356-15.036 13.354-20.564 14.65 -6.897 1.615-25.495 4.619-33.733 7.022 -6.667 1.942-12.664 8.876-14.86 13.622 -3.708 8.008-4.584 22.5-4.584 35h100 100C200 222.278 199.123 207.786 195.417 199.778z",
    fill: "#e9b995",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2894",
    d: "M159.156 184.058c24.342 3.542 34.586 8.708 37.794 50.721H200c0-12.5-0.877-26.992-4.583-35 -2.196-4.746-8.195-11.779-14.86-13.722 -8.239-2.403-26.837-5.308-33.733-6.923 -5.528-1.296-18.242-12.069-21.643-16.35 3.36 4.704 12.791 15.605 21.054 18.46C150.188 182.61 153.48 183.232 159.156 184.058zM53.766 181.244c8.263-2.854 17.693-13.756 21.054-18.46 -3.4 4.28-16.114 15.054-21.643 16.35 -6.896 1.615-25.494 4.619-33.733 7.022 -6.665 1.942-12.664 8.876-14.86 13.622 -3.706 8.008-4.583 22.5-4.583 35h3.05c3.188-41.744 13.475-47.183 37.794-50.721C46.52 183.232 49.813 182.61 53.766 181.244z",
    fill: "#f8d3b8",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2895",
    d: "M95.646 197.62c0 0-5.074-1.609-7.083-2.379 -10.449-4.009-44.395-6.607-44.395-6.607s35.754 1.419 43.644 2.779c-0.458-4.767-3.017-20.004-3.017-20.004s5.149 16.815 6.409 21.057C91.878 194.734 95.646 197.62 95.646 197.62zM106.445 196.278c-0.089 0.073-0.191 0.168-0.302 0.268C106.256 196.461 106.358 196.372 106.445 196.278zM95.646 197.62c0 0 2.893 2.992 4.347 3.03 1.91 0.051 4.828-2.899 6.151-4.104 -1.265 0.957-4.159 1.391-5.31 1.436C99.504 198.033 95.646 197.62 95.646 197.62zM116.664 190.101c-1.545 0.248-4.386 0.789-4.386 0.789l2.287-14.89c-0.646 3.071-4.474 16.211-8.12 20.278 1.91-1.616 6.158-2.391 8.324-2.704 10.236-1.484 10.232-1.483 41.062-4.94C155.831 188.634 126.76 188.479 116.664 190.101z",
    fill: "#daa075",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2896",
    d: "M195.417 199.778c-2.196-4.746-8.195-11.779-14.86-13.722 -8.239-2.403-26.837-5.308-33.733-6.923 -5.528-1.296-16.662-11.294-20.564-14.65 -0.7-0.6-1.273-1.839-1.287-2.76 -0.139-10.864 4.195-39.724 4.195-39.724H100 70.833c0 0 4.334 28.859 4.193 39.724 -0.011 0.921-0.587 2.16-1.285 2.76 -3.902 3.356-15.036 13.354-20.564 14.65 -6.897 1.615-25.495 4.619-33.733 7.022 -6.667 1.942-12.664 8.876-14.86 13.622 -3.708 8.008-4.584 22.5-4.584 35h100 100C200 222.278 199.123 207.786 195.417 199.778z",
    fill: "none",
    stroke: "#bb7440",
    strokeWidth: 1.5,
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-chinshadow-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4588",
    d: "M117.136 169.742c2.515-1.069 5.217-3.028 7.927-5.519 -0.494-0.746-0.828-1.684-0.841-2.49 -0.093-7.296 1.775-22.369 3.054-31.753 -15.779-1.925-38.771-1.917-54.549 0.014 1.278 9.384 3.145 24.446 3.05 31.738 -0.01 0.789-0.348 1.735-0.84 2.485 2.712 2.493 5.416 4.454 7.932 5.524C90.312 172.907 109.693 172.907 117.136 169.742z",
    fill: "url(#SvgjsLinearGradient4589)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-clothes-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4511",
    d: "M-3.682 236.192c-2.914-24.293 8.022-47.09 34.496-54.611 7.77-2.208 5.691-3.341 6.867-3.41 -0.039-0.211-0.045-0.2-0.045-0.63h-0.036c0.087-8.03 9.028-6.453 11.587-6.984 10.121-2.158 13.558-12.786 25.115-9.985 0.284 2.437 0.075 5.248-1.371 15.663 10.899 23.466 22.722 21.437 26.925 34.571 3.815-11.746 17.339-13.617 27.306-34.576 -0.655-5.884-2.083-11.033-1.482-15.935l0.057-0.042c7.744-2.583 11.127 0.874 14.21 3.854 9.397 9.083 14.382 3.325 19.085 7.457 1.871 1.659 2.547 3.997 2.547 6.518 21.412 3.11 45.974 9.898 41.089 57.481l0.096 0.104C181.094 235.667 57.546 241.095-3.682 236.192z",
    fill: "#28293d",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4512",
    d: "M100.268 209.685c4.229-10.638 16.946-13.132 26.543-32.755 0.098-0.108 0.347-0.591 0.656-1.237 -0.164-1.826-0.372-3.747-1.213-5.757 -0.522-3.35-0.939-6.489-0.587-9.535 1.974 0.578 3.842 1.262 5.12 2.66 1.882 2.052 0.455 5.609-1.346 9.042C126.063 186.844 117.594 197.493 100.268 209.685zM169.282 198.859c2.938 10.376 4.895 26.928 2.544 37.445 1.962-0.045 2.686-0.097 4.506-0.138C177.146 225.12 175.154 207.48 169.282 198.859zM137.604 200.735c-12.805 7.48-25.687 10.358-37.321 20.291 -11.64-9.904-24.647-11.637-37.453-19.108 -5.87-2.36-14.874-10.699-20.377-16.572 17.313 26.284 29.706 18.823 57.434 36.538 27.736-17.715 40.205-11.692 57.516-37.974C151.9 189.782 143.476 198.39 137.604 200.735zM99.81 210.936c-4.238-10.644-16.459-14.383-26.056-34.006 -0.093-0.108-0.343-0.591-0.652-1.237 0.156-1.826-0.262-3.841 0.586-5.857 0.521-3.358 0.748-6.092 0.393-9.132 -1.969 0.574-3.025 0.959-4.303 2.357 -1.88 2.052-0.453 5.609 1.347 9.042C74.502 186.844 82.479 198.74 99.81 210.936zM27.163 197.688c-4.305 9.396-4.34 27.432-3.528 38.479 1.821 0.041 2.548 0.093 4.506 0.138C25.791 225.787 26.379 208.26 27.163 197.688zM99.888 212.964c16.389-4.909 33.813-13.894 48.305-35.847 -13.084 17.643-32.525 28.063-47.926 34.455 -15.89-5.762-34.915-17.221-46.006-32.635C67.257 200.226 83.508 208.055 99.888 212.964z",
    fill: "#191a2e",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4513",
    d: "M202.762 235.667c-0.115 0-0.256 0.001-0.374 0.001 -0.427-48.615-27.497-50.574-42.48-53.725 -2.345 0-3.563-6.505-5.288-8.24 -1.467-1.475-12.769-1.475-16.348-11.169 0.583 0.513 1.131 1.052 1.674 1.573 9.397 9.083 14.382 3.325 19.085 7.457 1.871 1.659 2.547 3.997 2.547 6.518 21.412 3.11 45.974 9.898 41.089 57.481L202.762 235.667zM-3.968 236.84c0.114 0 0.255 0.001 0.376 0.001 4.759-38.632 16.029-50.811 43.543-55.364 3.451-1.313 1.634-3.81 3.362-5.544 1.467-1.468 9.627-1.5 20.924-13.389 -0.582 0.513-3.075 1.042-3.615 1.563 -9.398 9.083-16.485 6.51-19.088 7.457 -3.209 1.188-3.707 4.028-3.707 6.546 -21.414 3.111-44.161 14.974-41.702 58.626L-3.968 236.84z",
    fill: "#3a3b4c",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4514",
    d: "M161.69 177.978c0-9.858-9.265-7.895-13.529-8.812 -9.409-2.02-9.113-12.916-22.582-8.985 -0.574 4.657 0.516 8.738 1.473 15.997 -9.877 20.755-23.576 23.093-27.196 34.245 -3.957-12.38-16.045-11.134-26.81-34.171 1.498-10.838 1.648-13.354 1.36-15.774 -10.271-2.349-12.588 4.32-21.876 8.776 -5.637 2.642-7.229 0.263-12.067 2.633 -2.007 0.968-3.018 3.609-2.946 5.767 -0.013 0.01 0 0.01 0 0.01 0 0.139 0 0.267 0.023 0.396 -1.175 0.082 0.546 0.074-7.323 1.346 -25.363 4.1-36.61 25.534-34.005 56.906 11.89 0 1.011 4.382 183.147-0.077 8.456-0.214 22.799-0.447 23.402-0.447C208.321 189.265 184.836 181.568 161.69 177.978zM-3.624 236.057c2.579-36.004 8.018-50.026 41.046-57.329 17.978 29.839 39.98 25.499 62.232 42.189 -20.166-16.771-41.302-14.549-61.622-42.583 -0.228-2.354 1-4.943 3.535-5.959 1.796-0.702 3.72-0.498 5.6-0.488 7.087 0.054 12.546-5.502 17.793-9.578 2.499-1.67 6.22-1.752 9.2-1.292 0.231 3.874-1.262 9.721-1.762 13.845 -1.042-2.295-2.029-4.664-3.015-7.022 12.47 36.624 24.903 28.334 30.461 43.525 -1.177-0.327-21.014-7.468-36.822-23.188 -3.358-3.325-10.011-10.656-10.516-11.34 19.573 26.51 32.079 27.86 47.391 34.691 0 0.01 0.021 0.035 0.021 0.048 0.012 0.036 0.068 0.221 0.086 0.256 0.074-0.033 0.158-0.07 0.239-0.091 0.026-0.022 0.047-0.033 0.08-0.033 2.122-1.043 16.065-5.902 26.681-13.2 10.927-7.517 23.39-23.821 22.451-22.64 -18.253 18.573-21.075 22.785-49.212 35.67 -0.027 0-0.048-0.01-0.069-0.021 -0.022-0.131-0.064-0.257-0.107-0.387 0.011-0.062 0.032-0.121 0.054-0.178 4.948-13.579 19.476-8.33 31.51-45.554 -1.232 3.216-2.527 6.382-3.979 9.486 -0.457-5.455-2.042-9.756-1.865-14.247 2.084-0.693 7.742-1.022 9.308 0.542 6.529 5.586 7.059 9.677 17.696 9.677 3.411 0.02 7.871 0.45 8.375 6.708 -0.627 0.922-5.291 6.431-9.703 10.809 -15.438 15.368-29.249 15.664-50.619 32.007 0.521 0 1.605-1.131 2.029-1.418 16.712-11.864 28.719-11.677 44.085-24.249 7.082-5.785 13.897-15.044 14.63-16.222 0.022 0.013 0.059 0.013 0.079 0.013 28.198 4.853 42.321 15.462 40.764 57.069C76.043 234.783 58.884 238.145-3.624 236.057z",
    fill: "#05060f",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-head"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3149",
    d: "M45.671 84.344c-1.485-2.462-6.327-9.199-10.031-8.254 -3.012 0.772-2.973 4.971-3.206 7.455 -0.34 3.644-0.464 9.992 0.525 12.568 0.951 2.473 3.96 7.252 5.828 9.075 2.299 2.235 5.97 9.358 6.422 10.097 0.711 1.168 2.137 2.84 4.325 2.708 3.071-0.185 5.724-3.087 5.965-4.485C56.8 105.918 49.536 90.75 45.671 84.344z",
    fill: "#e9b995",
    stroke: "#bb7440",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3150",
    d: "M44.2 99.341c-0.143-0.563 0.007-1.513 0.154-2.429 0.133-0.835 0.258-1.624 0.182-2.182 -0.289-2.09-1.915-6.06-2.976-8.212 -1.223-2.476-3.199-5.595-5.679-6.399 -1.024-0.333-1.699 0.065-2.089 0.468 -0.288 0.296-0.353 0.645-0.259 0.687 0.095 0.041 0.307-0.248 0.617-0.519 0.254-0.222-0.508-0.04 0 0 -0.205 1.04-0.865 6.302-0.41 10.143 0.358 3.022 1.05 5.279 1.263 5.617 0.031 0.356 0.083 0.705 0.16 1.043 1.002 4.41 7.518 10.177 9.034 11.82 0.28 0.303 0.574 0.483 0.646 0.409s-0.101-0.373-0.379-0.678c-1.498-1.632-7.971-7.381-8.939-11.635 -1.027-4.514 3.912-11.207 4.699-12.623 0.401 0.665 0.742 1.303 1.004 1.835 0.207 0.417 0.434 0.906 0.67 1.435 -0.463 0.738-5.118 6.127-3.934 10.441 0.438 1.591 3.822 3.642 5.131 4.203 0.72 0.31 0.99 0.772 1.304 1.306 0.364 0.624 0.033 2.229 1.23 2.739 0.244 0.104 0.464 0.146 0.659 0.146 0.338 0 0.594-0.13 0.783-0.284 0.02 0.271 0.019 0.619 0.009 0.941 -0.012 0.418 0.047 0.609 0.148 0.617 0.103 0.009 0.21-0.174 0.223-0.587 0.017-0.51 0.014-1.141-0.077-1.444 -0.269-0.889-1.088-1.894-1.957-2.957C44.563 102.197 44.422 100.213 44.2 99.341zM34.969 95.432c-2.348-6.923 1.283-13.229 1.81-14.179 1.012 0.399 2.562 2.193 3.221 3.235C39.52 85.321 35.067 90.775 34.969 95.432zM45.772 106.464c-1.084-0.462-0.706-1.984-1.056-2.584 -0.318-0.542-0.646-1.102-1.479-1.46 -0.18-0.078-0.379-0.196-0.583-0.332 -2.682-6.075 0.293-8.73 1.039-9.273 0.229 0.742 0.399 1.423 0.476 1.97 0.068 0.5-0.059 1.298-0.181 2.068 -0.153 0.955-0.31 1.944-0.147 2.584 0.244 0.953 0.411 2.97 1.291 4.048 0.781 0.956 1.583 1.942 1.857 2.746C46.871 106.391 46.5 106.775 45.772 106.464z",
    fill: "#bb7440",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-ears-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3151",
    d: "M154.066 84.344c1.486-2.462 6.328-9.199 10.031-8.254 3.012 0.772 2.973 4.971 3.207 7.455 0.34 3.644 0.463 9.992-0.525 12.568 -0.951 2.473-3.961 7.252-5.828 9.075 -2.299 2.235-5.971 9.358-6.422 10.097 -0.711 1.168-2.137 2.84-4.326 2.708 -3.07-0.185-5.723-3.087-5.965-4.485C142.938 105.918 150.203 90.75 154.066 84.344z",
    fill: "#e9b995",
    stroke: "#bb7440",
    strokeWidth: 1.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3152",
    d: "M154.322 103.243c-0.869 1.063-1.688 2.068-1.957 2.957 -0.092 0.304-0.094 0.935-0.078 1.444 0.014 0.413 0.121 0.596 0.225 0.587 0.102-0.008 0.16-0.199 0.148-0.617 -0.01-0.322-0.012-0.67 0.008-0.941 0.189 0.154 0.445 0.284 0.783 0.284 0.195 0 0.416-0.042 0.66-0.146 1.195-0.511 0.865-2.116 1.229-2.739 0.314-0.534 0.584-0.997 1.305-1.306 1.309-0.561 4.693-2.611 5.131-4.203 1.184-4.314-3.471-9.704-3.934-10.441 0.234-0.529 0.463-1.018 0.668-1.435 0.264-0.532 0.604-1.171 1.006-1.835 0.787 1.416 5.725 8.108 4.699 12.623 -0.969 4.254-7.441 10.003-8.939 11.635 -0.279 0.305-0.453 0.604-0.381 0.678 0.074 0.074 0.367-0.106 0.646-0.409 1.516-1.643 8.031-7.41 9.033-11.82 0.078-0.338 0.131-0.687 0.162-1.043 0.211-0.337 0.904-2.594 1.262-5.617 0.455-3.841-0.205-9.103-0.41-10.143 0.508-0.04-0.254-0.222 0 0 0.311 0.271 0.523 0.56 0.617 0.519 0.094-0.042 0.029-0.39-0.258-0.687 -0.391-0.403-1.066-0.801-2.09-0.468 -2.48 0.804-4.457 3.923-5.68 6.399 -1.061 2.152-2.686 6.122-2.975 8.212 -0.076 0.558 0.049 1.347 0.182 2.182 0.146 0.916 0.297 1.866 0.154 2.429C155.316 100.213 155.176 102.197 154.322 103.243zM159.738 84.488c0.66-1.042 2.209-2.835 3.221-3.235 0.527 0.95 4.158 7.256 1.811 14.179C164.672 90.775 160.219 85.321 159.738 84.488zM152.75 106.229c0.273-0.804 1.076-1.79 1.857-2.746 0.879-1.078 1.047-3.095 1.291-4.048 0.162-0.64 0.006-1.629-0.146-2.584 -0.123-0.77-0.25-1.568-0.182-2.068 0.076-0.547 0.246-1.228 0.475-1.97 0.746 0.543 3.721 3.199 1.039 9.273 -0.203 0.136-0.402 0.254-0.584 0.332 -0.832 0.358-1.16 0.918-1.479 1.46 -0.35 0.6 0.029 2.123-1.055 2.584C153.238 106.775 152.867 106.391 152.75 106.229z",
    fill: "#bb7440",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-faceshape-wrap"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-faceshape-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4585",
    d: "M144.736 127.176c-4.549 9.887-17.57 28.302-27.601 32.566 -7.442 3.165-26.824 3.165-34.267 0 -10.029-4.265-23.05-22.68-27.601-32.566 -5.29-11.491-14.118-48.623-14.13-48.677 -1.3-4.996-1.996-10.239-2.004-15.645C39.082 28.806 66.289 1.169 99.907 1.116c33.621-0.053 60.913 27.495 60.963 61.543 0.009 5.408-0.669 10.653-1.952 15.653C158.901 78.365 150.045 115.641 144.736 127.176z",
    fill: "#e9b995",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4586",
    d: "M110.152 1.984c26.994 6.347 47.097 30.857 47.052 60.124 -0.009 5.407-0.704 10.65-2.004 15.646 -0.012 0.054-9.158 37.218-14.396 48.677 -4.417 9.659-16.244 27.271-25.867 31.821 -3.169 1.499-11.439 1.855-14.935 1.855 -3.494 0-11.765-0.356-14.933-1.855 -9.623-4.55-21.451-22.162-25.867-31.821 -5.239-11.459-14.385-48.623-14.396-48.677 -1.3-4.995-1.996-10.239-2.004-15.646C42.756 32.841 62.857 8.331 89.853 1.984 61.03 6.885 39.087 32.276 39.134 62.854c0.008 5.406 0.704 10.649 2.004 15.645 0.012 0.054 8.781 37.213 14.13 48.677 4.602 9.862 17.738 27.917 27.601 32.566 3.671 1.732 13.088 2.374 17.134 2.374 4.043 0 13.464-0.643 17.133-2.374 9.862-4.649 23-22.704 27.601-32.566 5.35-11.464 14.119-48.623 14.13-48.677 1.3-4.996 1.996-10.239 2.004-15.645C160.918 32.276 138.975 6.885 110.152 1.984z",
    fill: "#e1ac85",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4587",
    d: "M144.736 127.176c-4.549 9.887-17.57 28.302-27.601 32.566 -7.442 3.165-26.824 3.165-34.267 0 -10.029-4.265-23.05-22.68-27.601-32.566 -5.29-11.491-14.118-48.623-14.13-48.677 -1.3-4.996-1.996-10.239-2.004-15.645C39.082 28.806 66.289 1.169 99.907 1.116c33.621-0.053 60.913 27.495 60.963 61.543 0.009 5.408-0.669 10.653-1.952 15.653C158.901 78.365 150.045 115.641 144.736 127.176z",
    fill: "none",
    stroke: "#bb7440",
    strokeWidth: 1.5,
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mouth-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3078",
    d: "M100.2 142.947c-2.832 0.144-3.644-2.753-3.644-2.753s3.931 0.565 6.991-0.353C103.548 139.842 102.692 142.822 100.2 142.947z",
    fill: "url(#SvgjsLinearGradient3079)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3082",
    d: "M100.488 140.76c-1.984 0.1-3.765-0.077-3.877-0.089 -0.138-0.014-0.238-0.136-0.224-0.272 0.015-0.138 0.143-0.233 0.274-0.224 0.041 0.003 4.096 0.405 6.738-0.337 0.131-0.032 0.271 0.041 0.309 0.174s-0.04 0.27-0.173 0.308C102.601 140.582 101.517 140.708 100.488 140.76z",
    fill: "#bb7440",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3083",
    d: "M82.5 130.299c0 0 12.532 1.486 16.718 1.499 4.553 0.012 19.282-1.499 19.282-1.499 -4.258 3.534-8.943 6.932-19.555 6.999C89.453 137.359 87.021 133.912 82.5 130.299z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3084",
    d: "M82.5 130.299c0 0 12.532 1.486 16.718 1.499 4.553 0.012 19.282-1.499 19.282-1.499 -4.258 3.534-8.943 6.932-19.555 6.999C89.453 137.359 87.021 133.912 82.5 130.299z",
    fill: "none",
    stroke: "#bb7440",
    strokeWidth: 0.75,
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesback-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4172",
    d: "M60.432 80.957c1.226-1.179 9.091-2.674 13.631-2.075 7.183 0.947 13 7.285 13 7.285s-4.836 3.083-13.61 3.56C67.673 90.042 61.86 86.309 60.432 80.957z",
    fill: "url(#SvgjsRadialGradient4173)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriswrapper-left",
    transform: "translate(0.25 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriscontrol-left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiris-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4276",
    d: "M79.788 85.588c-0.869 3.192-4.162 5.073-7.361 4.196 -3.197-0.876-5.084-4.178-4.214-7.371 0.869-3.195 4.168-5.076 7.365-4.198C78.772 79.09 80.659 82.392 79.788 85.588z",
    fill: "#4d3623",
    stroke: "#1f1105",
    strokeWidth: 0.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4277",
    d: "M78.855 85.662c-0.849 2.452-3.407 3.881-5.899 3.199 -2.3-0.631-3.752-2.838-3.563-5.171 0.853-0.067 1.787-0.087 2.756-0.04 -0.01 0.033-0.027 0.062-0.036 0.096 -0.306 1.125 0.407 2.305 1.592 2.63 1.189 0.326 2.401-0.326 2.707-1.451 0.039-0.147 0.06-0.294 0.065-0.439C77.29 84.782 78.088 85.165 78.855 85.662z",
    fill: "#5c4633",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4278",
    d: "M74.813 82.21c-1.203-0.344-2.429 0.342-2.739 1.54 -0.311 1.191 0.412 2.438 1.614 2.783 1.204 0.345 2.43-0.342 2.741-1.534C76.742 83.801 76.016 82.555 74.813 82.21zM75.075 86.442c-0.5 0.156-1.017-0.051-1.154-0.462 -0.133-0.411 0.163-0.867 0.667-1.019 0.503-0.156 1.019 0.051 1.157 0.459C75.881 85.831 75.582 86.287 75.075 86.442z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4279",
    d: "M70.811 87.159c-0.37 0.222-0.922 0.023-1.238-0.447 -0.316-0.466-0.269-1.024 0.102-1.247 0.368-0.219 0.925-0.021 1.239 0.446C71.226 86.378 71.181 86.938 70.811 87.159z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4280",
    d: "M78.71 83.74c-0.846 0.507-2.117 0.051-2.837-1.02 -0.72-1.072-0.612-2.352 0.234-2.857 0.844-0.509 2.118-0.053 2.834 1.019C79.66 81.954 79.556 83.232 78.71 83.74z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.8
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesfront-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4197",
    d: "M55.132 85c0 13.808 12.668 20.999 18 20.999 9.94 0 18-7.191 18-20.999 0-13.809-8.06-25.001-18-25.001S55.132 71.191 55.132 85zM60.432 80.957c1.226-1.179 9.091-2.674 13.631-2.075 7.183 0.947 13 7.285 13 7.285s-4.836 3.083-13.61 3.56C67.673 90.042 61.86 86.309 60.432 80.957z",
    fill: "#e9b995",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4198",
    d: "M73.981 93.592c9.412 2.223 18.451-1.61 20.194-8.565 1.738-6.956-4.478-14.395-13.892-16.622 -9.414-2.224-18.453 1.609-20.195 8.565C58.35 83.927 64.564 91.365 73.981 93.592zM60.432 80.957c1.226-1.179 9.091-2.674 13.631-2.075 7.183 0.947 13 7.285 13 7.285s-4.836 3.083-13.61 3.56C67.673 90.042 61.86 86.309 60.432 80.957z",
    fill: "url(#SvgjsRadialGradient4199)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4203",
    d: "M60.432 80.957c1.226-1.179 9.091-2.674 13.631-2.075 7.183 0.947 13 7.285 13 7.285s-4.836 3.083-13.61 3.56C67.673 90.042 61.86 86.309 60.432 80.957z",
    fill: "url(#SvgjsRadialGradient4204)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4207",
    d: "M86.632 82.458c-6.502-4.251-4.054-3.09-16.23-6.703 3.344 0.5 9.572 2.066 11.707 3.32C83.272 79.729 85.632 81.584 86.632 82.458z",
    fill: "#bb7440",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4208",
    d: "M58.853 80.886c1.947 4.926 9.734 13.961 29.285 5.533 -3.097-3.36-11.005-9.113-18.159-9.063C63.986 77.397 60.637 79.265 58.853 80.886zM60.432 81.074c1.226-1.137 9.091-2.58 13.631-2.001 7.183 0.913 13 7.026 13 7.026s-4.836 2.974-13.61 3.434C67.673 89.836 61.86 86.236 60.432 81.074z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyes-right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesback-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4180",
    d: "M139.169 80.957c-1.226-1.179-9.091-2.674-13.631-2.075 -7.183 0.947-13 7.285-13 7.285s4.836 3.083 13.61 3.56C131.928 90.042 137.74 86.309 139.169 80.957z",
    fill: "url(#SvgjsRadialGradient4181)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriswrapper-right",
    transform: "translate(-0.25 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiriscontrol-right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesiris-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4281",
    d: "M131.788 85.588c-0.869 3.192-4.162 5.073-7.362 4.196 -3.196-0.876-5.084-4.178-4.214-7.371 0.869-3.195 4.169-5.076 7.365-4.198C130.772 79.09 132.658 82.392 131.788 85.588z",
    fill: "#4d3623",
    stroke: "#1f1105",
    strokeWidth: 0.5,
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4282",
    d: "M130.855 85.662c-0.849 2.452-3.408 3.881-5.899 3.199 -2.3-0.631-3.753-2.838-3.563-5.171 0.854-0.067 1.787-0.087 2.756-0.04 -0.01 0.033-0.027 0.062-0.036 0.096 -0.306 1.125 0.407 2.305 1.593 2.63 1.189 0.326 2.401-0.326 2.707-1.451 0.038-0.147 0.06-0.294 0.065-0.439C129.29 84.782 130.089 85.165 130.855 85.662z",
    fill: "#5c4633",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4283",
    d: "M126.813 82.21c-1.202-0.344-2.429 0.342-2.738 1.54 -0.312 1.191 0.412 2.438 1.613 2.783 1.204 0.345 2.431-0.342 2.742-1.534C128.741 83.801 128.016 82.555 126.813 82.21zM127.075 86.442c-0.5 0.156-1.018-0.051-1.154-0.462 -0.133-0.411 0.163-0.867 0.667-1.019 0.503-0.156 1.019 0.051 1.157 0.459C127.881 85.831 127.582 86.287 127.075 86.442z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4284",
    d: "M122.812 87.159c-0.37 0.222-0.923 0.023-1.238-0.447 -0.316-0.466-0.27-1.024 0.102-1.247 0.367-0.219 0.926-0.021 1.239 0.446C123.227 86.378 123.181 86.938 122.812 87.159z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4285",
    d: "M130.71 83.74c-0.846 0.507-2.116 0.051-2.837-1.02 -0.72-1.072-0.612-2.352 0.234-2.857 0.845-0.509 2.117-0.053 2.834 1.019C131.66 81.954 131.557 83.232 130.71 83.74z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.8
  })))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyesfront-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4218",
    d: "M126.469 59.999c-9.94 0-18 11.193-18 25.001 0 13.808 8.06 20.999 18 20.999 7.201 0 18-7.191 18-20.999C144.469 71.191 136.409 59.999 126.469 59.999zM126.148 89.727c-8.774-0.476-13.61-3.56-13.61-3.56s5.817-6.338 13-7.285c4.54-0.6 12.405 0.896 13.631 2.075C137.74 86.309 131.928 90.042 126.148 89.727z",
    fill: "#e9b995",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4219",
    d: "M139.512 76.971c-1.742-6.956-10.781-10.79-20.195-8.565 -9.414 2.227-15.63 9.666-13.892 16.622 1.743 6.955 10.782 10.788 20.194 8.565C135.036 91.365 141.251 83.927 139.512 76.971zM126.148 89.727c-8.774-0.476-13.61-3.56-13.61-3.56s5.817-6.338 13-7.285c4.54-0.6 12.405 0.896 13.631 2.075C137.74 86.309 131.928 90.042 126.148 89.727z",
    fill: "url(#SvgjsRadialGradient4220)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4224",
    d: "M139.169 80.957c-1.226-1.179-9.091-2.674-13.631-2.075 -7.183 0.947-13 7.285-13 7.285s4.836 3.083 13.61 3.56C131.928 90.042 137.74 86.309 139.169 80.957z",
    fill: "url(#SvgjsRadialGradient4225)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4228",
    d: "M112.969 82.458c6.502-4.251 4.054-3.09 16.23-6.703 -3.344 0.5-9.572 2.066-11.707 3.32C116.328 79.729 113.969 81.584 112.969 82.458z",
    fill: "#bb7440",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4229",
    d: "M129.622 77.355c-7.154-0.05-15.063 5.703-18.159 9.063 19.551 8.428 27.338-0.607 29.285-5.533C138.964 79.265 135.614 77.397 129.622 77.355zM126.148 89.533c-8.774-0.459-13.61-3.434-13.61-3.434s5.817-6.113 13-7.026c4.54-0.579 12.405 0.864 13.631 2.001C137.74 86.236 131.928 89.836 126.148 89.533z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-facehighlight-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2885",
    d: "M141 113.974c0.035 22.622-18.292 40.994-40.938 41.025 -22.642 0.037-41.028-18.273-41.063-40.9 -0.035-22.62 18.292-41.064 40.937-41.1C122.579 72.964 140.967 91.349 141 113.974z",
    fill: "url(#SvgjsRadialGradient2886)",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath2889",
    d: "M137.5 53.999c0 20.711-16.789 37.5-37.499 37.5 -20.711 0-37.501-16.789-37.501-37.5s16.79-37.5 37.501-37.5C120.711 16.499 137.5 33.288 137.5 53.999z",
    fill: "url(#SvgjsRadialGradient2890)",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-left",
    transform: "translate(0 -4.0000003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4583",
    d: "M55.992 72.441c14.723-3.028 32.888 2.77 33.336-0.649 0.164-1.252-0.892-1.729-1.755-1.795C72.692 68.733 60.5 68.555 55.992 72.441z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-eyebrows-right",
    transform: "translate(0 -4.0000003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4584",
    d: "M144.008 72.441c-14.724-3.028-32.888 2.77-33.336-0.649 -0.164-1.252 0.892-1.729 1.755-1.795C127.308 68.733 139.5 68.555 144.008 72.441z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-nose-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3146",
    d: "M96.831 88.524c0 0-1.399 11.117-2.026 13.281 -1.379 4.752-6.168 11.417-5.239 14.429 1.859 6.022 7.537 4.493 10.524 4.471 2.763-0.022 8.072 1.552 9.162-2.37 0.352-1.266-0.441-4.466-0.441-4.466s-2.644 3.112-8.875 2.767c-1.778-0.099-4.671-2.096-4.704-4.912 -0.043-3.817 1.802-7.035 2.205-10.824C97.741 98.022 96.831 88.524 96.831 88.524z",
    fill: "#daa075",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3147",
    d: "M105.194 118.969c1.075 0 1.366 0.326 1.366 0.729 0 0.404-0.335 1.026-1.366 0.73 -1.134-0.323-3.113-0.175-3.113-0.175S104.117 118.969 105.194 118.969zM94.922 118.969c-1.077 0.001-1.366 0.328-1.366 0.733 -0.001 0.403 0.323 0.983 1.366 0.729 1.15-0.282 3.112-0.175 3.112-0.175S95.999 118.973 94.922 118.969zM108.81 113.869c0 0 1.489 1.933 1.18 3.975 -0.301 1.983-3.31 2.861-3.31 2.861s2.089-1.516 2.342-3.356C109.14 116.486 108.81 113.869 108.81 113.869zM90.427 111.883c0 0-1.086 2.704-0.772 4.352 0.571 2.976 3.704 4.164 3.704 4.164s-1.955-2.039-2.65-3.842C89.948 114.587 90.427 111.883 90.427 111.883z",
    fill: "#bb7440",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath3148",
    d: "M105.141 115.311c1.043-0.889 1.148-1.396 0.932-1.729 -0.215-0.334-0.841-0.545-1.714 0.528 -0.963 1.18-3.056 2.054-3.056 2.054S104.098 116.198 105.141 115.311z",
    fill: "#f8d3b8",
    strokeWidth: "none",
    opacity: 1,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-beardwrap"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svga-group-beard-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4446",
    d: "M100,18.13L100,18.13L100,18.13L100,18.13z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-mustache-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4444",
    d: "M100,18.13L100,18.13L100,18.13L100,18.13z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-hair-front"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4440",
    d: "M45.777 90.313c-2.998-2.502-6.749-8.939-8.423-17.962 -0.356-1.849-0.61-3.75-0.88-5.763 -1.131-8.446-3.555-18.289-1.878-28.373 2.013-12.337 11.271-25.693 23.036-33.237 18.191-11.772 64.171-17.033 73.754-1.537 5.559-0.203 11.557 1.249 15.699 4.471 13.709 10.284 19.01 45.211 15.211 62.559 -2.528 11.847-3.191 14.954-8.264 19.599 1.812-54.323-0.99-39.665-3.306-54.253 -2.715-1.99-3.727-1.168-7.909-3.542 -8.318-6.142-7.915-8.602-11.683-12.898 -3.356 3.969-8.181 7.463-11.907 9.077 0.944-1.547 1.749-3.282 2.282-4.398l-0.446-0.373c-3.129 2.262-9.451 5.478-13.336 5.823 2.087-2.565 1.843-2.242 2.677-3.805 -3.116 1.916-6.427 3.217-10.604 3.583 3.935-1.944 5.699-3.274 8.751-5.817l-0.279-0.518c-21.191 6.437-26.218 7.895-41.755 10.651 -13.012 1.627-8.248 0.252-12.968 0.252 -7.593 0-8.798 22.789-8.47 30.387C45.925 85.479 44.837 81.343 45.777 90.313z",
    fill: "#2a232b",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4441",
    d: "M162.296 70.471c-2.528 11.847-3.191 14.954-8.264 19.599 1.812-54.323-0.99-39.665-3.306-54.253 -2.715-1.99-3.727-1.168-7.909-3.542 -8.318-6.142-7.915-8.602-11.683-12.898 -3.356 3.969-8.181 7.463-11.907 9.077 0.944-1.547 1.749-3.282 2.282-4.398l-0.446-0.373c-3.129 2.262-9.451 5.478-13.336 5.823 2.087-2.565 1.843-2.242 2.677-3.805 -3.116 1.916-6.427 3.217-10.604 3.583 3.935-1.944 5.699-3.274 8.751-5.817l-0.279-0.518c-21.191 6.437-26.218 7.895-41.755 10.651 -13.012 1.627-8.248 0.252-12.968 0.252 -7.593 0-8.798 22.789-8.47 30.387 0.846 21.241-0.242 17.104 0.698 26.075 -2.998-2.502-6.749-8.939-8.423-17.962 -0.356-1.849-0.61-3.75-0.88-5.763 -1.131-8.446-3.555-18.289-1.878-28.373 1.59-9.746 13.727-24.08 22.024-31.729 -25.5 23.75-18 50.252-13.75 71.5C41.619 59.235 38 29 55 28c23 0 48.869-3.265 64.869-19.265C118.869 15.735 118 17 113 22c4-3 9-5 11-10 -1 4-1 7-4 10 3-2 6-5 9-8 0 3-2 6-3 9 2-5 8-8 9-13 -3 13 12.369 19.985 17.119 22.735 6.5 9 6.75 28 5.25 43.75 5.5-18 3-48.75-13.25-70C161.869 19.485 165.6 55.386 162.296 70.471zM60.369 19.985c12.207-0.359 21.165-2.337 34.25-9.75C82.032 15.751 74.067 18.383 60.369 19.985zM93.619 15.735c6.46-2.681 10.955-8.497 18.25-10.25C105.146 7.818 100.471 13.67 93.619 15.735zM54.869 19.485c4.629-8.324 14.52-15.222 27-16.25C71.713 5.123 60.837 10.953 54.869 19.485z",
    fill: "#1b141c",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4442",
    d: "M86.619 0c13.085-5.594 24.996-5.023 37.5 1.985 -13.123-5.605-23.154-4.532-23.154-4.532C98.577-2.36 94.759-2.452 86.619 0zM138.119 7.985c4.139 1.594 5.866 4.016 8.383 7.511 3.685 5.954 4.716 8.533 6.863 14.489C151.28 21.431 146.603 10.292 138.119 7.985zM114.619 7.735c-7.115 6.003-12.274 9.237-26.5 14C99.361 19.065 106.526 15.916 114.619 7.735zM137.619 13.985c2.067 7.036 5.876 10.957 11.75 14.5C143.909 24.378 140.339 20.566 137.619 13.985zM58.619 10.235c0 0-0.486 0.36-1.287 0.952 -9.145 6.479-16.294 18.86-16.463 34.548C42.864 30.127 49.049 19.143 58.619 10.235zM63.369 14.735c7.757-4.055 11.339-4.087 24.25-6.25C76.476 9.262 70.964 9.793 63.369 14.735zM84.417 18.964c-4.565 2.29-15.277 4.855-15.277 4.74 -3.757 0.834-10.27 2.281-10.27 2.281 2.522-0.319 6.849-0.825 10.418-1.591 0 0.135 8.796-1.985 11.379-3.319 2.836-1.338 1.875-0.813 4.703-2.59C85.369 18.485 85.008 18.667 84.417 18.964z",
    fill: "#3a353a",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4443",
    d: "M147.27 7.675c-4.229-3.289-10.323-4.741-15.721-4.54 -4.611-7.454-19.151-9.598-27.97-9.69 -13.304-0.138-34.324 3.653-46.11 11.28 -10.968 7.032-21.023 20.286-23.17 33.44 -1.284 7.721-0.178 15.721 1.13 23.38 0.64 3.7 0.97 7.43 1.63 10.86 1.897 10.227 6.295 16.626 9.09 18.57 -1.065-9.855 0.097-4.998-0.77-26.75 -0.403-9.331 1.305-30.714 8.49-30.06 4.883 0.345 1.014 1.191 12.7-0.271 15.347-2.722 20.366-4.152 41.79-10.659 -3.357 2.798-5.103 4.068-9.6 6.22 -0.01-0.01-0.01 0-0.01 0 -0.14 0.07-0.29 0.14-0.43 0.2 3.719-0.024 8.346-1.305 11.299-3.12 -0.407 0.762-1.632 2.147-2.539 3.3 3.844 0 10.74-3.438 14.16-5.91 -0.48 1-1.603 3.462-2.811 5.21 1.141-0.57 3.874-1.313 9.33-5.93 1.11-0.93 2.38-2.19 3.38-3.37 3.349 3.818 3.148 6.516 11.53 12.7 4.158 2.36 5.282 1.625 7.78 3.45 2.206 14.448 5.134-0.795 3.26 54.78 5.6-4.96 6.275-8.026 8.88-20.23C166.297 53.602 161.249 18.163 147.27 7.675zM160.949 70.325c-2.216 12.286-2.402 14.36-6.88 19.22 0.814-10.8 1.53-20.459 1.319-31.34 -0.444-16.061-2.58-13.048-4.1-22.72 -2.878-2.021-4.273-1.655-6.92-2.85 -0.46-0.17-0.84-0.46-1.27-0.68 -8.392-5.824-8.398-8.604-11.83-12.27 0.971-1.114 1.813-2.391 2.09-2.94 -1.509 2.264-7.977 8.239-14.11 11.63 1.059-1.676 1.864-3.305 2.44-4.78 1.735-1.212 2.92-2.358 3.92-3.35 -3.419 2.84-12.225 7.96-17.75 9.07 0.174-0.179 1.875-1.826 2.516-3.074 1.355-0.542 5.016-2.779 6.304-4.203 -6.304 4.203-13.475 6.72-15.979 7.136 3.064-1.149 7.04-4.731 9.08-6.36 1.971-1.574 2.353-2.206 4.399-4.28 -1.344 0.938-3.44 2.993-6.056 4.097 -1.547 0.653-43.89 12.498-51.254 10.574 -1.478-0.37-3.149-0.818-4.62-0.39 -11.8 5.076-7.461 37.634-7.3 47.63 0.136 8.423 0.74 9.89 0.74 9.89 -7.751-7.36-8.089-23.554-8.9-29.18 -1.028-7.456-1.923-15.371-0.55-22.77 2.24-12.64 11.912-25.407 22.26-32.06 15.469-10.04 61.594-18.533 73.04-2.83C159.954 3.495 163.94 50.271 160.949 70.325z",
    fill: "#000000",
    strokeWidth: "none",
    opacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "svga-group-glasses-single"
  }, /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4515",
    d: "M143.62 100.1c-2.36 2.2-6.23 3.04-13.56 3.04 -9.78 0-16.18-1.09-20.41-9.51 -3.29-6.54-4.62-13.56-3.02-15.98 2.21-3.34 8.57-5.61 15.67-6.28C134.63 77.23 143.29 88.98 143.62 100.1zM72.01 71.17c-7.64 0.21-15.09 2.35-18.27 7.05 -2.18 3.21-1.69 12.55-0.22 16.94 2 5.99 5.07 7.98 16.42 7.98 9.78 0 16.18-1.09 20.41-9.51 0.42-0.84 0.81-1.69 1.17-2.54C88.29 82.95 81.16 75.43 72.01 71.17z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4516",
    d: "M146.48 95.17c-0.71 2.12-1.56 3.73-2.86 4.94 -0.33-11.12-8.99-22.87-21.33-28.74 9.37-0.89 19.99 0.99 23.97 6.86C148.44 81.44 147.95 90.77 146.48 95.17zM93.38 77.65c-2.79-4.23-12.22-6.73-21.37-6.47 9.16 4.25 16.28 11.77 19.52 19.92C93.94 85.36 94.77 79.76 93.38 77.65z",
    fill: "#ffffff",
    strokeWidth: "none",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4517",
    d: "M151.79 73.61c-10.18-5.46-36.14-7.01-45.5 0.15 -0.8 0.47-4.23-0.53-6.29-0.53 -1.95 0-5.42 1.05-6.29 0.53 -9.36-7.16-35.32-5.61-45.5-0.15 -1.46 0.79-1.62 4.51-0.35 5.08 0.91 0.41 1.51 0.98 1.46 1.98C49 86.29 50.55 93.59 51.23 95.6c0.87 2.59 2.44 7.41 9.29 8.6 5.83 1.01 16.43 1.48 21.94-0.17 9.99-2.98 14.24-18.04 14.42-23.17l0.01 0.02c0.4-1.8 5.82-1.8 6.23 0l0.01-0.02c0.17 5.13 4.43 20.19 14.42 23.17 5.51 1.65 16.11 1.18 21.94 0.17 6.85-1.19 8.42-6.01 9.29-8.6 0.68-2.02 2.23-9.31 1.92-14.93 -0.05-1 0.56-1.57 1.46-1.98C153.41 78.12 153.25 74.4 151.79 73.61zM81.41 101.36c-5.06 1.51-14.32 1.61-19.71 0.67 -4.54-0.79-6.44-3.26-7.7-7.03 -1.48-4.4-1.87-13.51 0.16-16.5 6.76-9.98 33.87-8.05 38.8-0.58C95.16 81.27 90.89 98.53 81.41 101.36zM146 95.01c-1.26 3.77-3.17 6.24-7.7 7.03 -5.39 0.94-14.65 0.84-19.71-0.67 -9.48-2.83-13.75-20.09-11.55-23.44 4.93-7.47 32.04-9.4 38.8 0.58C147.87 81.49 147.48 90.61 146 95.01z",
    fill: "#2c2c2c",
    strokeWidth: "none",
    opacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "SvgjsPath4518",
    d: "M118.58 101.32c2.79 0.83 6.86 1.24 10.85 1.27 -12.54 1.22-15.39-3.4-17.12-5.16 -3.52-3.59-5.69-8.95-5.85-16.65C106.49 86.86 110.76 98.99 118.58 101.32zM93.69 73.72c-9.36-7.16-35.32-5.62-45.5-0.15C71.43 67.05 84.93 70.42 93.69 73.72zM61.68 102c-4.54-0.79-6.44-3.26-7.7-7.03 -1.32-3.93-1.77-11.62-0.4-15.35 -1.83 4.22-1.12 12.39 0.26 16.5 1.6 4.8 4.54 7.18 17.34 6.46C67.71 102.65 64.25 102.44 61.68 102zM152.97 76.3c-0.04-1.13-0.45-2.32-1.2-2.73 -9.98-5.36-35.14-6.94-44.93-0.25C120 68.05 138.97 67.31 152.97 76.3z",
    fill: "#3b3b3b",
    strokeWidth: "none",
    opacity: 1
  }))))), /*#__PURE__*/React.createElement("rect", {
    id: "SvgjsRect1036",
    width: 200,
    height: 15,
    x: 0,
    y: 185,
    fill: "#ecf0f1",
    opacity: 0.5,
    style: {
      display: "none"
    }
  }), /*#__PURE__*/React.createElement("text", {
    id: "SvgjsText1037",
    fontFamily: "\"Roboto\", \"Helvetica Neue\", Helvetica, Arial, sans-serif",
    style: {
      fontSize: "0.84em",
      fontFamily: "&quot",
      textAnchor: "middle",
      fontWeight: 400,
      display: "none"
    },
    fontSize: "0.84em",
    textAnchor: "middle",
    fontWeight: 400,
    fill: "#000000",
    x: 100,
    y: 185
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "SvgjsTspan1038",
    dy: "1.2em",
    x: 100,
    style: {
      fontSize: "0.84em",
      fontFamily: "&quot",
      textAnchor: "middle",
      fontWeight: 400
    }
  }, "Created on AvatarMaker.com"))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1001"
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient2886",
    cx: 100,
    cy: 114,
    r: 41,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-facehighlight-gradient-single-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2887",
    stopOpacity: 0.5,
    stopColor: "#f8d3b8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2888",
    stopOpacity: 0,
    stopColor: "#e9b995",
    offset: 0.9
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient2890",
    cx: 100,
    cy: 54,
    r: 37,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-facehighlight-gradient-single-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2891",
    stopOpacity: 0.5,
    stopColor: "#f8d3b8",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop2892",
    stopOpacity: 0,
    stopColor: "#e9b995",
    offset: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient3079",
    x1: 100,
    y1: 142,
    x2: 100,
    y2: 139,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-mouth-gradient-single-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3080",
    stopOpacity: 1,
    stopColor: "#e1ac85",
    offset: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop3081",
    stopOpacity: 1,
    stopColor: "#daa075",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4173",
    cx: 126.452,
    cy: 84.563,
    r: 15.179,
    gradientTransform: "matrix(-0.9148 0.0479 0.0523 0.9986 184.4328 -6.6013)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesback-gradient-left-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4174",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4175",
    stopOpacity: 1,
    stopColor: "#fdfefe",
    offset: 0.544
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4176",
    stopOpacity: 1,
    stopColor: "#f6f8f9",
    offset: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4177",
    stopOpacity: 1,
    stopColor: "#eaeff2",
    offset: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4178",
    stopOpacity: 1,
    stopColor: "#d9e3e8",
    offset: 0.992
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4179",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4181",
    cx: 126.017,
    cy: 84.585,
    r: 15.179,
    gradientTransform: "matrix(0.9148 0.0479 -0.0523 0.9986 15.5672 -6.6013)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesback-gradient-right-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4182",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4183",
    stopOpacity: 1,
    stopColor: "#fdfefe",
    offset: 0.544
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4184",
    stopOpacity: 1,
    stopColor: "#f6f8f9",
    offset: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4185",
    stopOpacity: 1,
    stopColor: "#eaeff2",
    offset: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4186",
    stopOpacity: 1,
    stopColor: "#d9e3e8",
    offset: 0.992
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4187",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4189",
    cx: 126.452,
    cy: 84.563,
    r: 15.179,
    gradientTransform: "matrix(-0.9148 0.0479 0.0523 0.9986 184.4328 -6.6013)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-left-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4190",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4191",
    stopOpacity: 1,
    stopColor: "#fdfefe",
    offset: 0.544
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4192",
    stopOpacity: 1,
    stopColor: "#f6f8f9",
    offset: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4193",
    stopOpacity: 1,
    stopColor: "#eaeff2",
    offset: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4194",
    stopOpacity: 1,
    stopColor: "#d9e3e8",
    offset: 0.992
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4195",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4199",
    cx: 122.781,
    cy: 80.48,
    fx: 136.429,
    fy: 80.114,
    r: 16.914,
    gradientTransform: "matrix(0.99 0.1411 0.1085 -0.7608 -53.0622 124.3787)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-left-3"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4200",
    stopOpacity: 1,
    stopColor: "#daa075",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4201",
    stopOpacity: 0.3,
    stopColor: "#daa075",
    offset: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4202",
    stopOpacity: 0,
    stopColor: "#e9b995",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4204",
    cx: 70.049,
    cy: 105.782,
    r: 29.51,
    gradientTransform: "matrix(1.0336 0 0 1.0336 -1.9413 1.255)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-left-4"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4205",
    stopOpacity: 0,
    stopColor: "#000000",
    offset: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4206",
    stopOpacity: 0.2,
    stopColor: "#000000",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4210",
    cx: 126.017,
    cy: 84.585,
    r: 15.179,
    gradientTransform: "matrix(0.9148 0.0479 -0.0523 0.9986 15.5672 -6.6013)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-right-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4211",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4212",
    stopOpacity: 1,
    stopColor: "#fdfefe",
    offset: 0.544
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4213",
    stopOpacity: 1,
    stopColor: "#f6f8f9",
    offset: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4214",
    stopOpacity: 1,
    stopColor: "#eaeff2",
    offset: 0.879
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4215",
    stopOpacity: 1,
    stopColor: "#d9e3e8",
    offset: 0.992
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4216",
    stopOpacity: 1,
    stopColor: "#d8e2e7",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4220",
    cx: 122.382,
    cy: 80.48,
    fx: 136.03,
    fy: 80.114,
    r: 16.914,
    gradientTransform: "matrix(-0.99 0.1411 -0.1085 -0.7608 252.2674 124.4351)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-right-3"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4221",
    stopOpacity: 1,
    stopColor: "#daa075",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4222",
    stopOpacity: 0.3,
    stopColor: "#daa075",
    offset: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4223",
    stopOpacity: 0,
    stopColor: "#e9b995",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4225",
    cx: 70.436,
    cy: 105.782,
    r: 29.51,
    gradientTransform: "matrix(-1.0336 0 0 1.0336 201.9413 1.255)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesfront-gradient-right-4"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4226",
    stopOpacity: 0,
    stopColor: "#000000",
    offset: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4227",
    stopOpacity: 0.2,
    stopColor: "#000000",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4232",
    cx: -568.659,
    cy: -521.042,
    r: 59.751,
    gradientTransform: "matrix(0.096 -0.0248 0.0245 0.0961 141.2814 119.9893)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4233",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4234",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4236",
    cx: -582.838,
    cy: -519.099,
    r: 59.745,
    gradientTransform: "matrix(0.0991 8.856319e-004 -0.0011 0.0991 131.1134 135.9855)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-2"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4237",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4238",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient4242",
    x1: 122.67,
    y1: 88.268,
    x2: 123.606,
    y2: 87.152,
    gradientTransform: "matrix(1 0 0 1 -52 0)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-5"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4243",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4244",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient4246",
    x1: 127.212,
    y1: 82.296,
    x2: 126.463,
    y2: 83.189,
    gradientTransform: "matrix(1 0 0 1 -52 0)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-6"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4247",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4248",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient4250",
    x1: 129.636,
    y1: 79.822,
    x2: 127.91,
    y2: 81.879,
    gradientTransform: "matrix(1 0 0 1 -52 0)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-left-7"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4251",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4252",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4255",
    cx: -568.654,
    cy: -521.042,
    r: 59.752,
    gradientTransform: "matrix(0.096 -0.0248 0.0245 0.0961 193.2804 119.9894)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-1"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4256",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4257",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SvgjsRadialGradient4259",
    cx: -582.833,
    cy: -519.102,
    r: 59.747,
    gradientTransform: "matrix(0.0991 8.856319e-004 -0.0011 0.0991 183.1126 135.9856)",
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-2"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4260",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4261",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient4265",
    x1: 122.67,
    y1: 88.268,
    x2: 123.606,
    y2: 87.152,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-5"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4266",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4267",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient4269",
    x1: 127.212,
    y1: 82.296,
    x2: 126.463,
    y2: 83.189,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-6"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4270",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4271",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient4273",
    x1: 129.636,
    y1: 79.822,
    x2: 127.91,
    y2: 81.879,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-eyesiris-gradient-right-7"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4274",
    stopOpacity: 1,
    stopColor: "#ffffff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4275",
    stopOpacity: 0,
    stopColor: "#ffffff",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SvgjsLinearGradient4589",
    x1: 100,
    y1: 172,
    x2: 100,
    y2: 128.5,
    gradientUnits: "userSpaceOnUse",
    className: "svga-on-canvas-chinshadow-gradient-single-0"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4590",
    stopOpacity: 0.8,
    stopColor: "#daa075",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    id: "SvgjsStop4591",
    stopOpacity: 1,
    stopColor: "#bb7440",
    offset: 0.7
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.137aa593c4bd5fb3553f54dacaf372f5.svg";
export { ForwardRef as ReactComponent };